/* components/ui/Toast.jsx — визуальный элемент тоста (тон = из _enums).
   Рендерится стопкой провайдером ToastProvider.
   Глиф берём из единого словаря тон→глиф (Badge.TONE_GLYPH) через мост
   семантический→badge-токен (enums.TONE_TOKEN) — Badge и Toast не дрейфуют (P2-04).
   Своей live-роли у тоста НЕТ (K-11): объявляет постоянная область провайдера
   (polite / assertive для ошибок) — роль status у динамически вставленного узла
   скринридеры объявляли ненадёжно. Ссылка в тексте — отдельный фрагмент .toast__url:
   на телефоне она режется многоточием, полный адрес — в title (C-49). */

import { Icon } from './Icon.jsx';
import { TONE_GLYPH } from './Badge.jsx';
import { enums as E } from '../../lib/enums.js';
import { normalizeTone, splitUrls } from './toastModel.js';

  function ToastMessage({ message }) {
    if (typeof message !== 'string') return message;
    return splitUrls(message).map((p, i) => (p.url
      ? <span key={i} className="toast__url" title={p.text}>{p.text}</span>
      : p.text));
  }

  function Toast({ message, tone = 'muted', onDismiss }) {
    const sem = normalizeTone(tone);                      // нормализуем к семантическому токену (success/danger/…)
    const glyph = TONE_GLYPH[E.TONE_TOKEN[sem]] || 'info'; // единый источник глифов (через TONE_TOKEN)
    return (
      <div className={`toast toast--${sem}`}>
        <span className="toast__glyph"><Icon name={glyph} size={16} /></span>
        <span className="toast__msg grow"><ToastMessage message={message} /></span>
        <button type="button" className="toast__close" onClick={onDismiss} aria-label="Закрыть уведомление">
          <Icon name="close" size={14} />
        </button>
      </div>
    );
  }

export { Toast };
